// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"23":"affiliate","177":"home","179":"main","757":"game","828":"emergency"}[chunkId] || chunkId) + "-legacy." + {"23":"1b0682c2","107":"ca92f994","177":"36e2cc9b","179":"ace3d614","757":"484c30a7","828":"4ecd4d7c","937":"f45bd210"}[chunkId] + ".js";
};